import React from "react"
import { Form } from "react-final-form"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { resetPasswordConfirmErrorTranslationKeys, ResetPasswordConfirmFormFieldNames } from "./types"
import { useSubmitHandler } from "./useSubmitHandler"
import { FormTitle } from "../../components/FormTitle"
import { PasswordField } from "../../components/PasswordField"
import { StyledLoginForm } from "../../components/StyledLoginForm"
import { SubmitButton } from "../../components/SubmitButton"

export const ResetPasswordConfirmForm = ({ executeOnSuccess }) => {
  const { i18n } = useTranslations()
  const {
    submitting, error, handleSubmit, cleanError
  } = useSubmitHandler(executeOnSuccess)

  return <Form onSubmit={handleSubmit}
               render={({ handleSubmit, values: { newPassword, newPasswordConfirm } }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                   <FormTitle
                     sx={{ marginBottom: "10px" }}>{i18n("Account.RestoreForgottenPassword:PasswordReset")}</FormTitle>

                   <Text>{i18n("Account.RestoreForgottenPassword:PasswordRule")}</Text>

                     <PasswordField name={ResetPasswordConfirmFormFieldNames.newPassword} textFieldProps={{
                       error: !!error,
                       placeholder: i18n("User:EnterNewPassword"),
                       disabled: submitting,
                       executeOnChange: cleanError,
                       id: NEW_PASSWORD_INPUT_ID
                     }}/>
                     <PasswordField name={ResetPasswordConfirmFormFieldNames.newPasswordConfirm} textFieldProps={{
                       error: !!error,
                       placeholder: i18n("User:ConfirmNewPassword"),
                       disabled: submitting,
                       executeOnChange: cleanError,
                       id: CONFIRM_PASSWORD_INPUT_ID,
                       helperText: !!error && <ErrorHelperText errorTranslationKey={error}/>
                     }}/>

                 <SubmitButton label={i18n("Account.RestoreForgottenPassword:Reset")} type="submit"
                               isLoading={submitting}
                               disabled={submitting}/>
               </StyledLoginForm>}/>
}

const Text = styled("div")({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "21px",
  letterSpacing: 0,
  marginBottom: "16px",
})

const ErrorHelperText = ({ errorTranslationKey }: { errorTranslationKey: string }) => {
  const { i18n } = useTranslations()
  const message = errorTranslationKey === resetPasswordConfirmErrorTranslationKeys.InvalidLength
    ? i18n(resetPasswordConfirmErrorTranslationKeys.InvalidLength).replace("{0}", "5")
    : i18n(errorTranslationKey)

  return <div>{message}</div>
}

const NEW_PASSWORD_INPUT_ID = "new-password-input-id"
const CONFIRM_PASSWORD_INPUT_ID = "confirm-password-input-id"
